import Box from '@mui/material/Box';

import { Typography } from '../Typography/Typography';

export const NoData = ({ children }: { children: React.ReactNode }) => (
  <Box
    sx={{
      alignItems: 'center',
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
    }}
  >
    <Typography color="secondary">{children}</Typography>
  </Box>
);
